/** Preserve guest preview and multipart constructor credentials across every game type. */
export function gameRequestHeaders(url: string, body?: object): Record<string, string> {
  const headers: Record<string, string> = {};
  let data: Record<string, unknown> = {};
  if (body instanceof FormData) {
    try {
      const parsed = JSON.parse(String(body.get('jsonData') || '{}'));
      if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) data = parsed;
    } catch { /* Server reports malformed JSON. */ }
  }
  // The last segment of /games/build/slot is a game type, not a build ID.
  const match = url.match(/\/(?:game-key\/by-build|public\/games\/build-data|game\/build)\/([^/?]+)/);
  const buildId = typeof data._id === 'string' && data._id ? data._id
    : typeof data.reservedBuildId === 'string' ? data.reservedBuildId : match?.[1];
  let credential = typeof data.reservedKey === 'string' ? data.reservedKey : undefined;
  if (!credential && body instanceof FormData) credential = String(body.get('reservedKey') || '') || undefined;
  if (!credential && buildId) {
    try { credential = localStorage.getItem(`game_preview_key_${buildId}`) || undefined; } catch { /* Storage may be unavailable. */ }
  }
  if (!credential) {
    try { credential = new URLSearchParams(window.location.search).get('key') || undefined; } catch { /* No browser location in tests. */ }
  }
  if (credential) headers['x-preview-key'] = credential;
  if (body instanceof FormData && /\/games\/build\//.test(url)) {
    if (credential) headers['x-editor-key'] = credential;
    if (buildId) headers['x-game-build-id'] = buildId;
  }
  return headers;
}
